import { MAP_ID_RE } from "./mapId";

export type RiflemanSkin = "pumpkin" | "santa" | "heart" | "tophat" | "bunny" | "propeller";

const EASTER_WINDOWS = [
  { start: "2027-03-25", end: "2027-03-29" },
  { start: "2028-04-13", end: "2028-04-17" },
] as const;

export function riflemanSkinForCalendarDate(calendarDate: string): RiflemanSkin | undefined {
  const monthDay = calendarDate.slice(5);
  if (monthDay === "10-31") return "pumpkin";
  if (monthDay >= "12-23" && monthDay <= "12-26") return "santa";
  if (monthDay === "02-14") return "heart";
  if (monthDay === "03-17") return "tophat";
  if (monthDay === "04-01") return "propeller";

  for (const window of EASTER_WINDOWS) {
    if (calendarDate >= window.start && calendarDate <= window.end) return "bunny";
  }
  return undefined;
}

export function riflemanSkinForMapId(mapId: string): RiflemanSkin | undefined {
  const match = MAP_ID_RE.exec(mapId);
  if (!match) return undefined;
  return riflemanSkinForCalendarDate(match[1]!);
}
